// @flow
import fetch from 'utils/fetch';
import { showErrorMessage } from 'actions/errorMessage';

import type { Feature2D } from 'flow-geojson';

export const USER_TEMPLATES_LOAD = 'userTemplates/LOAD';
export const USER_TEMPLATES_SAVE = 'userTemplates/SAVE';
export const USER_TEMPLATES_DELETE = 'userTemplates/DELETE';

function promptForTemplateName(dispatch, defaultName: ?string): ?string {
  const name = prompt('Új sablon neve', defaultName || '');

  if (!name) {
    dispatch(showErrorMessage('Írjon be egy nevet a sablon mentéséhez.'));
    return;
  }

  return name;
}

export function saveUserTemplateFromNotice(
  defaultName: ?string,
  sourceType: string,
  slug: string
) {
  return async (dispatch, getState) => {
    const name = promptForTemplateName(dispatch, defaultName);
    if (!name) {
      return;
    }

    const template = await (await fetch(`/api/v1/as/own`, {
      method: 'PUT',
      body: JSON.stringify({
        name,
        sourceType,
        slug,
        properties: {},
      }),
    })).json();

    if (template) {
      dispatch(showErrorMessage('Sablon mentve.'));
      dispatch({
        type: USER_TEMPLATES_SAVE,
        template,
      });
    }
  };
}

export function saveUserTemplate() {
  return async (dispatch, getState) => {
    const {
      drawOverlay: { feature },
    } = getState();

    const name = promptForTemplateName(dispatch);
    if (!name) {
      return;
    }

    const template = await (await fetch(`/api/v1/as/own`, {
      method: 'PUT',
      body: JSON.stringify({
        name,
        boundary: feature.geometry,
        properties: feature.properties || {},
      }),
    })).json();

    if (template) {
      dispatch(showErrorMessage('Sablon mentve.'));
      dispatch({
        type: USER_TEMPLATES_SAVE,
        template,
      });
    }
  };
}

export function deleteUserTemplate(id: number) {
  return async (dispatch, getState) => {
    const reply = confirm(
      'Biztosan törli a mentett sablont? A művelet nem vonható vissza.'
    );

    if (reply) {
      const result = await (await fetch(`/api/v1/as/own/${id}`, {
        method: 'DELETE',
      })).json();

      if (result) {
        dispatch(showErrorMessage('Sablon törölve.'));
        dispatch({
          type: USER_TEMPLATES_DELETE,
          id,
        });
      }
    }
  };
}

export function loadUserTemplates() {
  return async (dispatch, getState) => {
    const templates = await (await fetch(`/api/v1/as/own`)).json();

    dispatch({
      type: USER_TEMPLATES_LOAD,
      templates,
    });
  };
}



// WEBPACK FOOTER //
// ./actions/userTemplates.js